import styled from 'styled-components';

const HeaderLabel = styled.span`
    font-weight: 700;
    font-size: 1.1em;
`;
export default HeaderLabel;